/* Danish interface text, keyed by the English source exactly as the code
 * passes it to t() / uiText(). One file per area of the app; a key lives in
 * one file only (test/translations.test.ts checks). Wording follows
 * qorpera.com. */
/** Words and labels every area uses. */
export const SHARED: Record<string, string> = {
	General: "Generelt",
	Company: "Virksomhed",
	Account: "Konto",
	Retry: "Prøv igen",
	"Loading…": "Henter…",
	// Plan & usage and the thread both say it.
	"Out of computer hours. New work waits and starts by itself once hours are added.":
		"Ingen computertimer tilbage. Nyt arbejde venter og starter af sig selv, når der er tilføjet timer.",
	Appearance: "Udseende",
	Theme: "Tema",
	Light: "Lys",
	Dark: "Mørk",
	Language: "Sprog",
	"Follow system": "Følg systemet",
	English: "Engelsk",
	Danish: "Dansk",
	Close: "Luk",
	"Sign out": "Log ud",
	Feedback: "Feedback",
	"Share feedback": "Del feedback",
	"Staff at work": "Agenter på arbejde",
	"Company File": "Virksomhedsfilen",
	"Account and settings": "Konto og indstillinger",
	Friends: "Venner",
	"New agent": "Ny agent",
	Cancel: "Annuller",
	Back: "Tilbage",
	Open: "Åbn",
	Remove: "Fjern",
	Send: "Send",
	Settings: "Indstillinger",
	Agent: "Agent",
	Agents: "Agenter",
	Conversation: "Samtale",
	Message: "Besked",
	"Group chat": "Gruppechat",
	"Try again": "Prøv igen",
};
